import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { defineCustomElements, setAssetPath } from '@housekeep/web-components';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));

defineCustomElements();
setAssetPath(`${location.origin}/assets/web-components/`);
